export const isShowBanner = (auth, logged) => {
  if (auth === 'auth') return logged;

  if (auth === 'guest') return !logged;

  return true;
};
